import { RecentlyViewed } from '@theme/recently-viewed-products';

function formatPrice(price) {
  var n = parseFloat(price);
  if (isNaN(n)) return '';
  return '$' + n.toFixed(2).replace(/\.00$/, '');
}

function renderCard(item) {
  var card = document.createElement('div');
  card.className = 'zahav-recently-viewed-card';

  var soldOutHtml = item.available === false
    ? '<span class="zahav-recently-viewed-card__sold-out">Sold Out</span>'
    : '';
  var imgHtml = item.image
    ? '<img src="' + item.image + '" alt="" class="zahav-recently-viewed-card__img" loading="lazy" width="400" height="400">'
    : '';

  card.innerHTML =
    '<a href="/products/' + item.handle + '" class="zahav-recently-viewed-card__link">' +
      '<div class="zahav-recently-viewed-card__img-wrap">' + imgHtml + soldOutHtml + '</div>' +
      '<span class="zahav-recently-viewed-card__title">' + item.title + '</span>' +
      '<span class="zahav-recently-viewed-card__price">' + formatPrice(item.price) + '</span>' +
    '</a>';

  return card;
}

async function init(root) {
  var currentId = root.dataset.currentProductId;
  var maxProducts = parseInt(root.dataset.maxProducts, 10) || 4;
  var grid = root.querySelector('[data-zahav-recently-viewed-grid]');
  if (!grid) return;

  var ids = RecentlyViewed.getProducts().filter(function (id) {
    return String(id) !== String(currentId);
  });
  if (!ids.length) return;

  var query = ids.map(function (id) { return 'id:' + id; }).join(' OR ');
  var url = '/search/suggest.json?q=' + encodeURIComponent(query) +
    '&resources[type]=product&resources[limit]=' + ids.length;

  var products;
  try {
    var res = await fetch(url);
    var data = await res.json();
    products = (data.resources && data.resources.results && data.resources.results.products) || [];
  } catch (e) {
    return;
  }
  if (!products.length) return;

  var byId = {};
  products.forEach(function (p) { byId[String(p.id)] = p; });

  var ordered = ids
    .map(function (id) { return byId[String(id)]; })
    .filter(Boolean)
    .slice(0, maxProducts);
  if (!ordered.length) return;

  ordered.forEach(function (item) { grid.appendChild(renderCard(item)); });
  root.hidden = false;
}

document.querySelectorAll('[data-zahav-recently-viewed]').forEach(init);

export { init };
